import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { FaUser, FaUserCog } from "react-icons/fa";

import { getUser, hasAuthToken, isAdmin } from '../util/auth.jsx';

import UserMenu from './UserMenu.jsx';
import PatentMenu from './PatentMenu.jsx';
import TrademarkMenu from './TrademarkMenu.jsx';
import LitigationMenu from './LitigationMenu.jsx';

import classes from './SiteNavigation.module.css';

function SiteNavigation() {

  const Menues = {
    CLOSED: "Closed",
    PATENT: "Patent",
    TRADEMARK: "Trademark",
    LITIGATION: "Litigation",
    USER: "User"
  }

  const [menuOpen, setMenuOpen] = useState(Menues.CLOSED);

  function closeMenues() {
    setMenuOpen(Menues.CLOSED);
  };

  const toggleMenu = (menu) => {
    if (menuOpen === menu) {
      closeMenues();
    } else {
      setMenuOpen(menu);
    } 
  };

  return (
    <header className={classes.header}>
      <nav>
        <ul className={classes.list}>
          <li>
            <button onClick={() => {closeMenues()}}>
              <a href="https://staging.icsp.online/">
                <img src="icsp_logo.png" alt="ICSP Online" className={classes.logo} />
                <br></br>ICSP Online
                <br></br>Legal Services, Consolidated
              </a>
            </button>
          </li>
          <li></li>
          <li>
            <button onClick={() => {closeMenues()}}>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Home
            </NavLink>
            </button>
          </li>
          <li>
            <button onClick={() => {toggleMenu(Menues.PATENT)}}>
              Patent Services
            </button>
            {menuOpen === Menues.PATENT && <PatentMenu closeMenu={() => {closeMenues()}} />}
          </li>
          <li>
            <button onClick={() => {toggleMenu(Menues.TRADEMARK)}}>
              Trademark Services
            </button>
            {menuOpen === Menues.TRADEMARK && <TrademarkMenu closeMenu={() => {closeMenues()}} />}
          </li>
          <li>
            <button onClick={() => {toggleMenu(Menues.LITIGATION)}}>
              Litigation Services
            </button>
            {menuOpen === Menues.LITIGATION && <LitigationMenu closeMenu={() => {closeMenues()}} />}
          </li>
          <li>
            <button onClick={() => {closeMenues()}}>
            <NavLink
              to="/vendors"
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Services
            </NavLink>
            </button>
          </li>
          {hasAuthToken() ?
            <li>
              <button onClick={() => {toggleMenu(Menues.USER)}}>
                {isAdmin() ?
                  <FaUserCog />
                :
                  <FaUser />
                }
              </button><sub class="user"> {getUser()}</sub>
              {menuOpen === Menues.USER && <UserMenu closeMenu={() => {closeMenues()}} />}
            </li>
          :
            <li>
              <button onClick={() => {toggleMenu(Menues.USER)}}>
                <FaUser />
              </button>
              {menuOpen === Menues.USER && <UserMenu closeMenu={() => {closeMenues()}} />}
            </li>
          }
        </ul>
      </nav>
    </header>
  );
}

export default SiteNavigation;
